module.exports = __webpack_public_path__ + "static/media/flyrest-logo.1ede0498.jpg";